import { FC, SVGProps } from 'react'

import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

export const OverflowingChatMessageActionItem = ({
  icon: Icon,
  label,
  disabled,
  onClick,
}: {
  icon: FC<SVGProps<SVGElement>>
  label: string
  disabled?: boolean
  onClick?: () => void
}) => {
  return (
    <DropdownMenuItem
      onClick={onClick}
      disabled={disabled}
      className="hover:text-primary-500"
    >
      <Icon className="h-6 w-6" /> {label}
    </DropdownMenuItem>
  )
}
